module.exports = __webpack_public_path__ + "./fonts/icomoon.3c871d.woff";